import { Col, Form, Input, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { ScenarioModel } from "../../../../../models/scenario.model";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import AmountInput from "../../../../atoms/amount-input";
import { InfoCircleIcon } from "../../../../atoms/icon";
import { AppSelect } from "../../../../atoms/select";


const EstimatedDirectImpactSection = (props: FormSectionProps<ScenarioModel>) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbToleranceLevel")}
                        name="tolerance_level"
                        tooltip={{ title: t("Scenario.lbToleranceLevel"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("tolerance_level", props.requiredFields)}
                    >
                        <AmountInput />
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDirectEstimatedLossAmount")}
                        name="direct_estimate_loss_amount"
                        tooltip={{ title: t("Scenario.lbDirectEstimatedLossAmount"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("direct_estimate_loss_amount", props.requiredFields)}
                    >
                        <AmountInput />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDirectEstimatedLossComments")}
                        name="direct_estimate_loss_comments"
                        tooltip={{ title: t("Scenario.lbDirectEstimatedLossComments"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("direct_estimate_loss_comments", props.requiredFields)}
                    >
                        <Input placeholder={t("Global.plInputComment")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppSelect
                        list={props.resources?.direct_loss_types}
                        label={t("Scenario.lbDirectLossType")}
                        name="direct_loss_type_id"
                        tooltip={{ title: t("Scenario.lbDirectLossType"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("direct_loss_type_id", props.requiredFields)} />
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbExcessExpensesAmount")}
                        name="excess_expenses_amount"
                        tooltip={{ title: t("Scenario.lbExcessExpensesAmount"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("excess_expenses_amount", props.requiredFields)}>
                        <AmountInput />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbExcessExpensesComments")}
                        name="excess_expenses_comments"
                        tooltip={{ title: t("Scenario.lbExcessExpensesComments"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("excess_expenses_comments", props.requiredFields)}
                    >
                        <Input placeholder={t("Global.plInputComment")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbForgoneRevenueAmount")}
                        name="forgone_revenue_amount"
                        tooltip={{ title: t("Scenario.lbForgoneRevenueAmount"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("forgone_revenue_amount", props.requiredFields)}
                    >
                        <AmountInput />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbForgoneRevenueComments")}
                        name="forgone_revenue_comments"
                        tooltip={{ title: t("Scenario.lbForgoneRevenueComments"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("forgone_revenue_comments", props.requiredFields)}
                    >
                        <Input placeholder={t("Global.plInputComment")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24} className="text-total">
                    <p>{t("Scenario.lbMaximumEstimatedLoss")}</p><span>{AMOUNT_UTIL.convertNumericToFormattedAmount(props.data?.maximum_estimated_loss)}</span>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbOtherComments")}
                        name="other_comments"
                        tooltip={{ title: t("Scenario.lbOtherComments"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("other_comments", props.requiredFields)}
                    >
                        <Input placeholder={t("Global.plInputComment")} />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default EstimatedDirectImpactSection;